<div class="owner-data-card">
  <div class="owner-info-cont">
    @if (ticket.eventAttendee) {
      <div class="ticket-item-user-data">
        <i class="fa-regular fa-user icon-medium"></i>
        <div class="ticket-item-user-data-value">
          {{ ticket.eventAttendee.getName() }}
        </div>
      </div>
    } @else {
      <div class="ticket-item-user-data data-missing">
        <i class="fa-regular fa-user icon-medium"></i>
        <div class="ticket-item-user-data-value">
          {{ "APP.DATA_MISSING" | translate }}
        </div>
      </div>
      <div class="ticket-order-warning-cont">
        <i
          class="fa-regular fa-circle-exclamation icon-regular warning-icon"
        ></i>
      </div>
    }
  </div>
  @if (ticket.eventAttendee) {
    <button class="btn btn-sm btn-primary pop-color" (click)="viewData()">
      {{ "APP.TICKETS_DASHBOARD.VIEW_DATA" | translate }}
    </button>
  } @else {
    <button
      class="btn btn-sm btn-primary pop-color"
      (click)="onForwardTicket()"
    >
      {{ "APP.TICKETS_DASHBOARD.FORWARD_TICKET" | translate }}
    </button>
  }
</div>
